import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";

function buildNotaryBusinessApiCatalog(): Record<string, string> {
	const fm = COMMON_UI_I18N.folderMessages;
	return {
		...fm.thirdPartyNotaryApiValidation,
		...fm.folderSharingNotaryApiValidation,
		...fm.notaryOperationApiValidation,
		...fm.notaryBadRequestApiValidation,
	};
}

/** Résout un `code` API (ou un message égal au code) vers le libellé métier notaire. */
export function mapNotaryBusinessApiUserMessage(codeOrMessage: string | null | undefined): string | null {
	if (!codeOrMessage?.trim()) {
		return null;
	}
	const key = codeOrMessage.trim();
	const catalog = buildNotaryBusinessApiCatalog();
	return catalog[key] ?? null;
}
